import anime from 'animejs';

export function sliderInit(el) {
  const slides = el;
  const translateY = slides[0].getBoundingClientRect().top + slides[0].getBoundingClientRect().height + 100;

  anime.set(slides, {
    translateY,
    translateX: anime.stagger('20%', { grid: [4, 1], from: 'center', axis: 'x' }), // eslint-disable-line
  });
}

export function sliderAnim(el, delay = 0) {
  const slides = el;
  const tl = anime.timeline();
  if (window.innerWidth > 768) {
    tl
      .add({
        targets: slides,
        translateY: [
          {
            value: anime.stagger([0, 80], { from: 'center' }),
            delay,
          },
          {
            value: 0,
            easing: 'easeInOutQuint',
            delay: 0,
          },
        ],
        translateX: [
          {
            value: anime.stagger('60%', { grid: [4, 1], from: 'center', axis: 'x' }),
            delay,
          },
          {
            value: 0,
            easing: 'easeInOutQuint',
            delay: 0,
          },
        ],
        rotateZ: [
          {
            value: anime.stagger([0, 15], { grid: [4, 1], from: 'center', axis: 'x' }),
            delay,
          },
          {
            value: (el, i) => { // eslint-disable-line
              const multiplier = i === 0 ? 0 : i % 2 === 0 ? 1 : -1; // eslint-disable-line
              return multiplier * anime.random(3, 10);
            },
            easing: 'easeInOutQuint',
            delay: 0,
          },
        ],
        easing: 'easeOutCirc',
        duration: 1800,
      })
      .add({
        targets: slides[3],
        opacity: 0,
        duration: 400,
        easing: 'easeOutCirc',
      }, '-=300');
  } else {
    tl
      .add({
        targets: slides,
        scale: [1.5, 1],
        opacity: [
          { value: 0, duration: 0 },
          { value: 1, duration: 500 },
        ],
        translateX: [0, 0],
        translateY: [0, 0],
        rotateZ: [
          {
            value: (el, i) => { // eslint-disable-line
              const multiplier = i === 0 ? 0 : i % 2 === 0 ? 1 : -1; // eslint-disable-line
              return multiplier * anime.random(3, 10);
            },
          },
        ],
        easing: 'easeOutElastic(1, .85)',
        delay: anime.stagger(150, { from: 'last' }),
        duration: 1800,
      })
      .add({
        targets: '.puzzle__mask',
        opacity: [0, 1],
        delay: anime.stagger(150, { from: 'first' }),
      }, '-=1200')
      .add({
        targets: slides[3],
        opacity: 0,
        duration: 400,
        easing: 'easeOutCirc',
      }, '-=400');
  }

  return tl;
}

export function slidePrev(items, callback = () => {}) {
  let callbackDone = false;
  const tl = anime.timeline({
    easing: 'easeOutElastic(1, .9)',
    duration: 1200,
    update: (anim) => {
      if (anim.progress > 75 && !callbackDone) {
        callbackDone = true;
        callback();
      }
    },
  });
  tl
    .add({
      targets: items[3].$el,
      opacity: 0,
      scale: 0.8,
    }, 0)
    .add({
      targets: items[1].$el,
      rotateZ: (items[1].startIndex % 2 === 0 ? -1 : 1) * anime.random(3, 10),
    }, 400)
    .add({
      targets: items[0].$el,
      translateX: ['-50vw', 0],
      translateY: [80, 0],
      opacity: [0, 1],
      rotateZ: [-20, 0],
      scale: [1, 1],
    }, 0);

  return tl;
}

export function slideNext(items, isPanReverse = false, callback = () => {}) {
  let callbackDone = false;
  const tl = anime.timeline({
    easing: 'easeOutElastic(1, .9)',
    duration: 1200,
    update: (anim) => {
      if (anim.progress > (window.innerWidth > 768 ? 60 : 10) && !callbackDone) {
        callbackDone = true;
        callback(true);
      }
    },
  });
  tl.add({
    targets: items[3].$el,
    opacity: { value: 0, duration: 1200 },
    translateX: [
      { value: isPanReverse ? '-50vw' : '50vw', duration: 1400 },
      { value: 0, duration: 0 },
    ],
    translateY: [
      { value: 80 },
      { value: 0, duration: 0 },
    ],
    rotateZ: [
      { value: isPanReverse ? -10 : 10 },
      { value: (items[2].startIndex % 2 === 0 ? 1 : -1) * anime.random(3, 10), duration: 0 },
    ],
    complete: () => {
      items[3].$el.style.zIndex = 0;
    },
  })
    .add({
      targets: items[0].$el,
      rotateZ: 0,
      translateY: [0, 0],
      translateX: [0, 0],
      scale: [
        {
          value: 0.8,
          easing: 'easeOutCirc',
          duration: 600,
          complete: () => {
            anime.set(items[0].puzzleItemsHTMLElements, { scale: 1.01 });
          },
        },
        { value: 1 },
      ],
    }, 0)
    .add({
      targets: items[0].puzzleItemsHTMLElements,
      scale: 1,
      easing: 'easeOutCirc',
      duration: 600,
    }, 1000)
    .add({
      targets: items[1].$el,
      translateY: [0, 0],
      translateX: [0, 0],
      scale: [
        { value: 0.8, easing: 'easeOutCirc', duration: 600 },
        { value: 1 },
      ],
    }, 40)
    .add({
      targets: items[2].$el,
      translateY: [0, 0],
      translateX: [0, 0],
      scale: [
        { value: 0.8, easing: 'easeOutCirc', duration: 600 },
        { value: 1 },
      ],
      opacity: [0, 1],
    }, 80);

  return tl;
}
